import React from 'react';
import ServicePageTemplate from '../components/ServicePageTemplate';
import { MoreHorizontal } from 'lucide-react';

const OtherPage = () => (
  <ServicePageTemplate
    translationPrefix="otherPage"
    icon={MoreHorizontal}
    color="from-gray-500 to-gray-600"
    accentColor="bg-gray-50 border border-gray-200"
  />
);

export default OtherPage;
